// const { mobile } = require("is");

/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.bootstrap_barrio_subtheme = {
    attach: function (context, settings) {

    }
  };

  Drupal.behaviors.ignition_mobile_menu_toggle = {
    attach: function (context, settings) {
      once('ignition_mobile_menu_toggle', 'html', context).forEach(function(element) {

      const mobileMenu = $('.mobile-menu--container');
      const navToggle = $('.mobile-menu--toggle');

      navToggle.on("click", () => {
        const visibility = mobileMenu.attr("data-visible");
        if (visibility === "false") {
          mobileMenu.attr("data-visible", true);
          navToggle.attr("aria-expanded", true);
        } else {
          mobileMenu.attr("data-visible", false);
          navToggle.attr("aria-expanded", false);
        }
      });
    });
    }
  };

  //mitigates automatic height assignment on iframes
  //that causes excessive margins
  $( document ).ready(fixIframeHeight);
  $( window ).resize(fixIframeHeight);

  function fixIframeHeight() {
    var width = $('iframe').width();
    $('iframe').height(width*0.63);
  }
})(jQuery, Drupal, once);
